import ToggleByController from "./toggle_by_controller"

/**
 * Shows/hides an element based on the state of a checkbox, radio, or select input.
 * Inputs inside hidden elements are disabled to prevent form submission of hidden values.
 *
 * @example Radio button
 *   <input type="radio" name="option" value="a"> A
 *   <input type="radio" name="option" value="b"> B
 *
 *   <div data-controller="show-by" data-show-by-radio="[name=option]" data-show-by-value="a">
 *     Shown when A is selected
 *   </div>
 *
 * @example Checkbox
 *   <input type="checkbox" id="toggle">
 *   <div data-controller="show-by" data-show-by-checkbox="#toggle">
 *     Shown when checked
 *   </div>
 */
export default class extends ToggleByController {
  toggle = (isToggled) => {
    if (isToggled) {
      this.element.classList.remove("hidden")
      this._enableInputs()
    } else {
      this.element.classList.add("hidden")
      this._disableInputs()
    }
  }

  _enableInputs() {
    this.element
      .querySelectorAll(
        "input:not([type=hidden]):not(trix-toolbar input), textarea, select",
      )
      .forEach((input) => {
        input.disabled = false
        input.tomselect?.enable()
      })
  }

  _disableInputs() {
    this.element
      .querySelectorAll(
        "input:not([type=hidden]):not(trix-toolbar input), textarea, select",
      )
      .forEach((input) => {
        input.disabled = true
        input.tomselect?.disable()
      })
  }
}
